import store from "@/application/store/index";
import { AxiosError, InternalAxiosRequestConfig, AxiosResponse } from "axios";
import { isAxiosError } from "@/application/util/isAxiosError";

export const onRequestFulFilled = (
    request: InternalAxiosRequestConfig
): InternalAxiosRequestConfig => {
  const computedHeaders = computeHeaders();

  if (request.headers) {
    Object.keys(computedHeaders).forEach((header) => {
      request.headers[header] = computedHeaders[header];
    });
  }

  return request;
};
function computeHeaders(): Record<string, unknown> {
  return {
    Authorization: store.getters["authorisation/isLoggedIn"]
      ? `Bearer ${store.getters["authorisation/getAuthorisationToken"]}`
      : undefined,
  };
}

export const onRequestRejected = (error: AxiosError): AxiosError => {
  return error;
};

export const onResponseFulFilled = (response: AxiosResponse): AxiosResponse => {
  return response;
};

export const onResponseRejected = (
  error: AxiosError
): void | Promise<unknown> => {
  const { response } = error;

  if (!response || !isAxiosError(error)) return Promise.reject(error);

  const { status } = response;
  const { errors } = response.data as Record<string, any>;

  if (errors && status === 422) {
    Object.keys(errors).forEach((key) =>
      store.commit("error/add", {
        key,
        message: errors[key][0],
      })
    );
  }

  return Promise.reject(error);
};
